import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment.development';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  private handleError(error: HttpErrorResponse): Observable<never> {
    console.error('API Error:', error);
    return throwError(() => new Error(error.message || 'Server error'));
  }


  get(endpoint: string, params?: any): Observable<RemoteResponse> {
    return this.http
      .get<RemoteResponse>(`${this.baseUrl}/${endpoint}`, {
        params: params,
        withCredentials: true
      }).pipe(
      catchError(this.handleError)
    );
  }

  post(endpoint: string, body: any): Observable<RemoteResponse> {
    return this.http
      .post<RemoteResponse>(`${this.baseUrl}/${endpoint}`, body, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      }).pipe(
      catchError(this.handleError)
    );
  }
}

export interface RemoteResponse {
  success: boolean;
  data: Array<{
    dataFor: string;
    recordCount: number;
    dataSet: any;
    message: string;
  }>;
  dataError: Array<{
    number: number;
    description: string;
    message: string;
    critical: boolean;
    reference: string;
  }>;
}
